import { Component } from '@angular/core';

@Component({
  selector: 'app-confirmation-page',
  imports: [],
  templateUrl: './confirmation-page.component.html',
  styleUrl: './confirmation-page.component.css',
})
export class ConfirmationPageComponent {}
